import React from 'react';
import { Music, Music2, CheckCircle, Target, Package, ClipboardList, Star, Award } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-275">
      <div className="max-w-4xl mx-auto" data-id="element-276">
        {/* Title */}
        <div className="text-center mb-10 md:mb-12" data-id="element-277">
          <p className="font-nunito font-bold text-orange-500 text-base md:text-lg uppercase tracking-widest mb-2 flex items-center justify-center gap-2" data-id="element-278">
            <Music className="w-5 h-5" data-id="element-279" /> La Solución
          </p>
          <h2 className="font-nunito font-black text-gray-900 text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-280">
            PRESENTAMOS LA{' '}
            <span className="text-purple-700" data-id="element-281">SOLUCIÓN DEFINITIVA</span>
          </h2>
          <div className="flex items-center justify-center gap-3 mt-4" data-id="element-282">
            <div className="h-1 w-16 bg-orange-400 rounded-full" data-id="element-283" />
            <Music2 className="w-6 h-6 text-orange-400" data-id="element-284" />
            <div className="h-1 w-16 bg-orange-400 rounded-full" data-id="element-285" />
          </div>
        </div>

        {/* Product showcase */}
        <div className="bg-gradient-to-br from-orange-50 to-purple-50 rounded-3xl p-6 md:p-12 border-2 border-purple-200 mb-10 md:mb-12" data-id="element-286">
          <div className="flex flex-col items-center gap-6 md:gap-8" data-id="element-287">
            <img src="https://cdn.magicpatterns.com/uploads/gnFr5QhrYTY6A73VMFk3tp/36S.png" alt="36 Semanas de Música eBook" className="w-48 sm:w-56 md:w-64 rounded-xl shadow-xl flex-shrink-0" data-id="element-288" />
            <div className="text-center md:text-left" data-id="element-289">
              <h3 className="font-nunito font-black text-purple-800 text-2xl md:text-4xl mb-3 flex items-center justify-center md:justify-start gap-2" data-id="element-290">
                <Music className="w-7 h-7 text-purple-600 flex-shrink-0" data-id="element-291" />
                "36 SEMANAS DE MÚSICA"
              </h3>
              <p className="font-nunito font-bold text-gray-700 text-lg md:text-xl mb-4" data-id="element-292">
                1 Solo eBook PDF (60 páginas) — Todo incluido
              </p>
              <p className="text-gray-600 text-base md:text-lg mb-6" data-id="element-293">
                Planes + Plantillas + Certificados + Recursos. Imprime lo que
                necesites. Cero complicaciones.
              </p>
              <div className="bg-orange-100 rounded-xl p-4 border border-orange-200" data-id="element-294">
                <p className="font-nunito font-black text-orange-700 text-lg md:text-xl" data-id="element-295">
                  40 SEMANAS = 1 AÑO COMPLETO de clases de música listas
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 4 sections */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 mb-10 md:mb-12" data-id="element-296">
          <div className="bg-yellow-50 rounded-2xl p-6 border-l-4 border-yellow-400" data-id="element-297">
            <div className="flex items-start gap-3" data-id="element-298">
              <CheckCircle className="w-6 h-6 text-yellow-500 flex-shrink-0 mt-0.5" data-id="element-299" />
              <div data-id="element-300">
                <h4 className="font-nunito font-black text-gray-900 text-lg mb-1" data-id="element-301">
                  10 semanas PREESCOLAR
                </h4>
                <p className="text-purple-600 text-sm font-semibold mb-1" data-id="element-302">
                  (3-6 años)
                </p>
                <p className="text-gray-700" data-id="element-303">
                  Ritmo corporal, nanas mexicanas, instrumentos caseros
                </p>
              </div>
            </div>
          </div>

          <div className="bg-orange-50 rounded-2xl p-6 border-l-4 border-orange-400" data-id="element-304">
            <div className="flex items-start gap-3" data-id="element-305">
              <CheckCircle className="w-6 h-6 text-orange-500 flex-shrink-0 mt-0.5" data-id="element-306" />
              <div data-id="element-307">
                <h4 className="font-nunito font-black text-gray-900 text-lg mb-1" data-id="element-308">
                  10 semanas 1°-3° PRIMARIA
                </h4>
                <p className="text-purple-600 text-sm font-semibold mb-1" data-id="element-309">
                  Primeros grados
                </p>
                <p className="text-gray-700" data-id="element-310">
                  Juegos palmadas, flauta básica, cuentos musicales
                </p>
              </div>
            </div>
          </div>

          <div className="bg-purple-50 rounded-2xl p-6 border-l-4 border-purple-400" data-id="element-311">
            <div className="flex items-start gap-3" data-id="element-312">
              <CheckCircle className="w-6 h-6 text-purple-500 flex-shrink-0 mt-0.5" data-id="element-313" />
              <div data-id="element-314">
                <h4 className="font-nunito font-black text-gray-900 text-lg mb-1" data-id="element-315">
                  10 semanas 4°-6° PRIMARIA
                </h4>
                <p className="text-purple-600 text-sm font-semibold mb-1" data-id="element-316">
                  Grados superiores
                </p>
                <p className="text-gray-700" data-id="element-317">
                  Historia música México, coros, danzas folclóricas
                </p>
              </div>
            </div>
          </div>

          <div className="bg-green-50 rounded-2xl p-6 border-l-4 border-green-400" data-id="element-318">
            <div className="flex items-start gap-3" data-id="element-319">
              <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-320" />
              <div data-id="element-321">
                <h4 className="font-nunito font-black text-gray-900 text-lg mb-1" data-id="element-322">
                  10 semanas REPASO + VARIACIONES
                </h4>
                <p className="text-purple-600 text-sm font-semibold mb-1" data-id="element-323">
                  Consolidación
                </p>
                <p className="text-gray-700" data-id="element-324">
                  Festival, consolidación, actividades avanzadas
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Each plan includes */}
        <div className="bg-gray-900 rounded-3xl p-6 md:p-10" data-id="element-325">
          <h3 className="font-nunito font-black text-white text-xl md:text-3xl text-center mb-6 md:mb-8 flex items-center justify-center gap-2" data-id="element-326">
            <Target className="w-7 h-7 text-orange-400" data-id="element-327" />
            CADA PLAN INCLUYE:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4" data-id="element-328">
            <div className="flex items-start gap-3 bg-white/10 rounded-xl p-4" data-id="element-329">
              <Target className="w-6 h-6 text-orange-400 flex-shrink-0 mt-0.5" data-id="element-330" />
              <p className="text-white font-semibold" data-id="element-331">
                Objetivo SEP oficial (no inventado)
              </p>
            </div>
            <div className="flex items-start gap-3 bg-white/10 rounded-xl p-4" data-id="element-332">
              <Package className="w-6 h-6 text-yellow-400 flex-shrink-0 mt-0.5" data-id="element-333" />
              <p className="text-white font-semibold" data-id="element-334">
                Materiales CASEROS SOLO (cucharas, botellas, telas)
              </p>
            </div>
            <div className="flex items-start gap-3 bg-white/10 rounded-xl p-4" data-id="element-335">
              <Music className="w-6 h-6 text-purple-400 flex-shrink-0 mt-0.5" data-id="element-336" />
              <p className="text-white font-semibold" data-id="element-337">
                3-4 actividades numeradas paso a paso
              </p>
            </div>
            <div className="flex items-start gap-3 bg-white/10 rounded-xl p-4" data-id="element-338">
              <Music2 className="w-6 h-6 text-blue-400 flex-shrink-0 mt-0.5" data-id="element-339" />
              <p className="text-white font-semibold" data-id="element-340">
                Canción mexicana COMPLETA con letra
              </p>
            </div>
            <div className="flex items-start gap-3 bg-white/10 rounded-xl p-4" data-id="element-341">
              <ClipboardList className="w-6 h-6 text-green-400 flex-shrink-0 mt-0.5" data-id="element-342" />
              <p className="text-white font-semibold" data-id="element-343">
                Rúbrica evaluación lista (tabla imprimible)
              </p>
            </div>
            <div className="flex items-start gap-3 bg-white/10 rounded-xl p-4" data-id="element-344">
              <Star className="w-6 h-6 text-yellow-400 flex-shrink-0 mt-0.5" data-id="element-345" />
              <p className="text-white font-semibold" data-id="element-346">
                Dificultad y adaptaciones necesidades especiales
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}